<script setup lang="ts">
import { HaskoningTooltip } from "@haskoning/vue-component-library";
import { computed } from "vue";

const docUrl = computed(() => import.meta.env.VITE_DOC_URL);
</script>

<template>
  <HaskoningTooltip text="Documentation" location="top">
    <template v-slot:activator="{ props }">
      <v-btn
        v-bind="props"
        icon="mdi-information"
        color="--v-theme-onPrimary"
        variant="text"
        :href="docUrl"
        target="_blank"
      />
    </template>
  </HaskoningTooltip>
</template>
